export const parsePeopleDataForObjectDetail = (artist: string) => {
  const splittedArtist = artist.split('[;]')
  const nameWithDates = splittedArtist[0]
  const sourceID = splittedArtist[1]

  // Ad ve tarih ayrıştırma
  const nameMatch = nameWithDates.match(/^(.*?)\s*\((.*?)\)$/)
  const name = nameMatch ? nameMatch[1] : nameWithDates
  const dates = nameMatch ? nameMatch[2] : null

  return {
    name,
    dates,
    sourceID,
  }
}
